// `status` says whether processing finished; text_state says what the page IS.
export const FILE_PAGE_TEXT_STATE_VALUES = {
  hasText: 'has_text',
  blank: 'blank',
  noTextNeedsOcr: 'no_text_needs_ocr',
  ocrRecovered: 'ocr_recovered',
  error: 'error',
} as const;

export type FilePageTextState =
  (typeof FILE_PAGE_TEXT_STATE_VALUES)[keyof typeof FILE_PAGE_TEXT_STATE_VALUES];

export const FILE_PAGE_TEXT_STATE_LABELS: Record<FilePageTextState, string> = {
  has_text: 'Has text',
  blank: 'Blank page',
  no_text_needs_ocr: 'Needs OCR',
  ocr_recovered: 'OCR recovered',
  error: 'Error',
};
